import {
  Box,
  BoxProps,
  HStack,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { RiEyeLine } from 'react-icons/ri';
import { LinkButton } from '../../../../../../../../../components/LinkButton';
import { Pagination } from '../../../../../../../../../components/Pagination';
import { IAppointmentPaymentReport } from '../../../../../../../../../services/Appointments/ListAppointmentPaymentReportsService';

export interface IAppointmentPaymentsReportTableItem
  extends IAppointmentPaymentReport {
  formattedAuthorizedAt: string;
  formattedStartAt: string;
  formattedFinishAt: string;
  formattedPrice: string;
}

interface IAppointmentPaymentsReportTableProps extends BoxProps {
  paymentReports: IAppointmentPaymentsReportTableItem[];
  currentPage?: number;
  onPageChange?: (page: number) => void;
  totalPages?: number;
}

export const AppointmentPaymentsReportTable = ({
  paymentReports,
  currentPage,
  onPageChange,
  totalPages,
  ...rest
}: IAppointmentPaymentsReportTableProps): JSX.Element => (
  <Box {...rest}>
    <Table colorScheme="blue" mt="4">
      <Thead>
        <Tr>
          <Th textAlign="center" w="8">
            #OS
          </Th>

          <Th>Comprador</Th>

          <Th>Item</Th>

          <Th textAlign="center" w="8">
            Quantidade
          </Th>

          <Th>Período</Th>

          <Th>Valor</Th>

          <Th>Status</Th>

          <Th>Tipo</Th>

          <Th>Centro de custo</Th>

          <Th>Código</Th>

          <Th>Tipo (produto)</Th>

          <Th>Natureza</Th>

          <Th>Tipo de nota</Th>

          <Th textAlign="right" w="8" />
        </Tr>
      </Thead>

      <Tbody>
        {paymentReports.map((paymentReport) => (
          <Tr key={paymentReport.appointmentId.concat(paymentReport.productId)}>
            <Td textAlign="center" w="8">
              <Text>{String(paymentReport.code).padStart(6, '0')}</Text>
            </Td>

            <Td>
              <Text>{paymentReport.billingUserName}</Text>
            </Td>

            <Td>
              <Text>{paymentReport.productName}</Text>
            </Td>

            <Td textAlign="center">
              <Text>{paymentReport.quantity}</Text>
            </Td>

            <Td>
              <HStack spacing="3">
                <Text fontSize="sm" color="gray.400">
                  de:
                </Text>
                <Text>{paymentReport.formattedStartAt}</Text>
              </HStack>
              <HStack spacing="2">
                <Text fontSize="sm" color="gray.400">
                  até:
                </Text>
                <Text>{paymentReport.formattedFinishAt}</Text>
              </HStack>
            </Td>

            <Td>
              <Text>{paymentReport.formattedPrice}</Text>
            </Td>

            <Td>
              <Text>{paymentReport.paymentStatus}</Text>
            </Td>

            <Td>
              <Text>{paymentReport.paymentType}</Text>
            </Td>

            <Td>
              <Text>{paymentReport.costCenter}</Text>
            </Td>

            <Td>
              <Text>{paymentReport.productCode}</Text>
            </Td>

            <Td>
              <Text>{paymentReport.productType}</Text>
            </Td>

            <Td>
              <Text>{paymentReport.productNature}</Text>
            </Td>

            <Td>
              <Text>{paymentReport.invoiceType}</Text>
            </Td>

            <Td textAlign="right">
              <LinkButton
                px={0}
                to={{
                  pathname: '/services/appointments/details',
                  state: {
                    appointmentId: paymentReport.appointmentId,
                  },
                }}
              >
                <Icon as={RiEyeLine} fontSize="16" />
              </LinkButton>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>

    {!!currentPage && !!onPageChange && !!totalPages && totalPages > 1 && (
      <Pagination
        currentPage={currentPage}
        onPageChange={onPageChange}
        totalPages={totalPages}
      />
    )}
  </Box>
);
